// eslint-disable-next-line import/prefer-default-export
export function isError(e:any): e is Error {
  if (typeof e !== 'object') return false;
  if ((e as Record<string, unknown>).message) return true;
  return false;
}
